// `caption.transcribe`: a clip's speech as timed words for the editor's captions (#239).
// The editor's Generate captions starts it for each clip; live lists no such job, and a Studio
// draft never holds one.
import { CaptionTranscribeQuote, CaptionTranscribeRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"caption.transcribe"> = {
  type: "caption.transcribe",
  label: "Captions",
  source: "form",
  pair: "caption.transcribe",
  fields: () => ({}),
  request: CaptionTranscribeRequest,
  quote: CaptionTranscribeQuote,
};
